import { SupporterImporter, type SupporterImporterProps } from '@components/imports/SupporterImporter'
import { PageLayout } from '@components/layouts/PageLayout'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('supporter_imports')

export type GroupImportsNewProps = Omit<SupporterImporterProps, 'groupName'> & {
  group: { id: number; name: string }
}

export default function GroupImportsNew({ group, ...importer }: GroupImportsNewProps) {
  return (
    <PageLayout.Root>
      <PageLayout.Header
        icon="upload-cloud-02"
        heading={t('heading')}
        subtitle={t('group_subtitle', { group: group.name })}
      />
      <PageLayout.Body>
        <SupporterImporter {...importer} groupName={group.name} />
      </PageLayout.Body>
    </PageLayout.Root>
  )
}
